export const instr_brainstorm =
  'Carefully read the writing prompt and make a list of ideas and outlines that you want to include in your writing. Take your time and think about different thoughts and plans for your writing.';
export const instr_planning =
  'Take the first step in crafting a great essay by outlining your ideas. Use the provided tips as a guide if you’d like. Take your time, explore your thoughts, and feel free to get support and feedback from tutor Ivy.';
export const instr_editing =
  'To edit your essay, simply highlight the words or sentences you want to change. Afterward, you could request feedback and helpful editing suggestions from tutor Ivy.';

export const instr_relay_start =
  'Read the instruction, unleash your imagination, and have fun creating your story. Let the adventure begin!';
export const instr_relay_middle =
  'Read the story so far, let your imagination go wild, and add your twist! Keep it flowing, keep it fun—your turn to shine!';
export const instr_relay_end_opt =
  'Catch up on the story so far, let your imagination run wild, add your magic, and feel free to wrap it up if you’re ready. Just remember—have fun and make it epic!';
export const instr_relay_end =
  'It’s the grand finale! Wrap up the story with your creative magic—make it epic, funny, or totally unexpected. Tie it all together and end with a bang! You’ve got this!';
export const notify_skip =
  'Congrats, you’ve got a skip card! Take a break or keep the story going—it’s your call, storyteller! ';
export const notify_skipped =
  'Heads up! Ivy just got a skip card and decided to sit this round out. Your turn to shine!';
export const notify_both_skip =
  'Guess what? Ivy just used her skip card! And now, you’ve got one too! You can skip or jump in and keep the story going—take your pick, storyteller!';

export const STOP_WORDS = [
  'a',
  'the',
  'in',
  'on',
  'of',
  'at',
  'to',
  'and',
  'is',
  'it',
  'for',
  'with',
  'as',
  'by',
];
